import get from 'lodash-es/get'
import set from 'lodash-es/set'

export const pickFields = <T extends { _type: string }>(
  values: T,
  fields: string[],
  // `DeepPartial` would be more accurate but all our fields except `_type`
  // are optional already anyway (and this function always picks `_type`.)
): Partial<T> & Pick<T, '_type'> => {
  const typeFields = new Set(
    // Assumes `fields` only has leaf fields.
    // Otherwise it's wrong to replace e.g. `"foo.1"` with `"foo._type"`.
    fields.map((field) => field.replace(/(?<=^|\.)\w+/, '_type')),
  )

  const result = {
    _type: get(values, '_type'),
  } as Partial<T> & Pick<T, '_type'>
  for (const field of typeFields) {
    set(result, field, get(values, field))
  }
  for (const field of fields) {
    set(result, field, get(values, field))
  }

  return result
}
